import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */

const IconPlay = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-gallery' + (className ? ` ${className}` : '')}
            fill='none'
            height='10'
            viewBox='0 0 7 9'
            width='10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M0 7.69687V0.674791C0 0.465346 0.0679166 0.300485 0.20375 0.180208C0.339444 0.0600687 0.497778 0 0.67875 0C0.736666 0 0.796389 0.00909717 0.857917 0.0272916C0.919583 0.0453472 0.980209 0.0716662 1.03979 0.106249L6.43896 3.63292C6.53951 3.70153 6.61833 3.78326 6.67542 3.87812C6.73264 3.97299 6.76125 4.07667 6.76125 4.18917C6.76125 4.30167 6.73264 4.40535 6.67542 4.50021C6.61833 4.59507 6.53951 4.67458 6.43896 4.73875L1.03958 8.26792C0.979861 8.3025 0.918264 8.32847 0.854792 8.34583C0.791181 8.36306 0.729583 8.37167 0.67 8.37167C0.49125 8.37167 0.33493 8.3116 0.201042 8.19146C0.0670138 8.07118 0 7.90632 0 7.69687ZM1.08333 6.93583L5.34938 4.18583L1.08333 1.43583V6.93583Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconPlay;
